import { call, put, takeEvery } from "redux-saga/effects";
import i18next from "i18next";
import * as actionTypes from "../../constants/ActionTypes/UserAccount";
import { _CALLGETAPI } from "../../api/apiHandler";
import {
  _API_ENDPOINT,
  USER_LANGUAGE_CODE_TYPE,
  LOCALSESSIONDATAKEYS,
  SIGNUPTYPE,
  SUBSCRIPTIONKIND,
  _BROTHER_PLUS_API_ENDPOINTS,
  UPGRADE_TO_ECOPRO,
  BMC_ENROLMENT_TYPE,
  _ECOPRO_C4C_API_ENDPOINTS,
  QUERY_PARAMS
} from "../../constants/AppConstants";
import { setUserData, setLocalSessionData, getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { setLangCode, getLanguagePrefix } from "../../utils/Internationalization/handleAppInternationalization";
import { isAdministratorRole } from "../../constants/UserRoles";
import {
  currentUserRolesArr,
  getSignupTypeBy_SubscriptionKind,
  getSubscriptionkindBy_SignupType,
  Is_BrotherPlus_Signup,
  ISC4CSERVICEAGENT,
  isDesktopOrBmcClient,
  validatesHwIncBySubscriptionKind
} from "../../constants/AppMethod";
import { WebCustomerRoutePaths, WebHardwareInclusiveRoutePath } from "../../constants/Routes";
import { SOURCE_MY_DEVICE } from "../../pages/MyDevices/components/SuppliesComponent";

class DetailedError extends Error {
  constructor(message, extraInfo) {
    super(message);
    this.name = "UserAccount_RedirectErr";
    this.extraInfo = extraInfo;
  }
}

const getEnrollmentService = (subscriptionkind) => {
  const isHwInc = validatesHwIncBySubscriptionKind(subscriptionkind);
  return (subscriptionkind === SUBSCRIPTIONKIND.WEB || isHwInc)
    ? BMC_ENROLMENT_TYPE.BMC_AS_POST_ENROLLMENT_SERVICE
    : BMC_ENROLMENT_TYPE.BMC_AS_ENROLLMENT_SERVICE
}

function _FETCHUSERACCOUNTAPI(ADB2C, UID, deviceId, type, source) {
  const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
  const isC4CAgent = ISC4CSERVICEAGENT();
  const searchParams = new URLSearchParams(window.location.search);
  const role = searchParams.get('role');

  const endpoint = isC4CAgent
    ? _ECOPRO_C4C_API_ENDPOINTS.GET_C4C_USER_ACCOUNT
    : ((type === SIGNUPTYPE.BROTHER_PLUS && type !== UPGRADE_TO_ECOPRO) ||  source === SOURCE_MY_DEVICE)
      ? _BROTHER_PLUS_API_ENDPOINTS.GET_USER_ACCOUNT
      : _API_ENDPOINT.GET_USER_ACCOUNT;

  const UserCountryCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE);
  const UserLanguageCode = getLanguagePrefix();
  const SIGNUP_TYPES = [SIGNUPTYPE.WEB, SIGNUPTYPE.HARDWARE_INCLUSIVE];
  const payload = isC4CAgent ?
    {
      params: {
        roleName: role,
      },
    }
    :
    {
      params: {
        adb2cId: ADB2C,
        UserId: (UID) ? UID : "",
        deviceId: (deviceId) ? deviceId : "",
        countryCode: UserCountryCode,
        languageCode: UserLanguageCode,
        subscriptionKind: type !== null ? getSubscriptionkindBy_SignupType(type) : null
      },
    };



  return _CALLGETAPI(endpoint, payload)
    .then((response) => {
      const currentUserRoles = currentUserRolesArr();
      if(SIGNUP_TYPES.includes(type) === false && !IsBrotherPlus_Signup && !isDesktopOrBmcClient()){
        if(
            (!response.userId || !response.deviceId) 
            && !isAdministratorRole(currentUserRoles)
          ){
            throw new DetailedError(i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"), {subscriptionKind: response?.subscriptionKind});
          }
      }
      const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
      const deviceID = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
      if (!UID && response.userId) {
        setLocalSessionData(LOCALSESSIONDATAKEYS.UID, response.userId);
      }
      if (!deviceID && response.deviceId) {
        setLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID, response.deviceId);
      }
      const BOLUserdata = {
        "personal_details": {},
        "billing_address": {},
        "shipping_address": {}
      };
      setLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE, response.countryCode.toUpperCase());
      if (SIGNUP_TYPES.includes(type) === false && !isAdministratorRole(currentUserRoles) && !IsBrotherPlus_Signup) {
        setLangCode(response.languageCode, USER_LANGUAGE_CODE_TYPE);
      }
      const formedUserData = {
        ...BOLUserdata,
        personal_details: {
          'firstName': response.firstName,
          'lastName': response.lastName,
          'emailAddress': response.emailAddress,
          'displayName': response.displayName,
          'mobileNumber': response.mobileNumber,
          'telephoneNumber': response.phoneNumber
        },
        billing_address: response.billingAddress,
        shipping_address: response.shippingAddress,
        businessModel: response.personalOrBusiness,
        vatId: response.vatNumber,
        taxId: response.taxCode,
        langCode: response.languageCode,
        countryCode: response.countryCode,
        sapBpId: response.businessPartnerId,
        marketingEmails: response.marketingEmails,
        SubscriptionKind: response.subscriptionKind
      }
      setUserData(formedUserData);
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function* fetchUserAccount(action) {
  try {
    const ADB2CID = action.ADB2C;
    const UID = action.UID;
    const deviceID = action.deviceId;
    const type = action.signUpType;
    const source = action.source
    const isC4CAgent = ISC4CSERVICEAGENT();

    if (ADB2CID || isC4CAgent) {
      const userAccount = yield call(
        _FETCHUSERACCOUNTAPI,
        ADB2CID,
        UID,
        deviceID,
        type,
        source
      );
      if (userAccount.adB2CUserId === ADB2CID || isC4CAgent) {
        yield put({
          type: actionTypes.FETCH_USER_ACCOUNT_SUCCESS,
          userAccount: { ...userAccount, ...{ enrollmentService: getEnrollmentService(userAccount?.subscriptionKind) } },
        });
      } else {
        throw new DetailedError(i18next.t("ERROR_CONTENT.ADB2C_NOT_ASSOCIATED_WITH_BOL"), { subscriptionKind: userAccount?.subscriptionKind });
      }
    } else {
      yield put({
        type: actionTypes.FETCH_USER_ACCOUNT_ERROR,
        message: i18next.t('ERROR_CONTENT.INFO_GENERAL')
      });
    }
  } catch (e) {
    let redirectPage = WebCustomerRoutePaths.SELECT_PRINTER;
    const msg = (e?.response?.status === 404) ? i18next.t('ERROR_CONTENT.ADB2C_NOT_ASSOCIATED_WITH_BOL') : e.message;
    if (e?.extraInfo?.subscriptionKind) {
      setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, getSignupTypeBy_SubscriptionKind(e?.extraInfo?.subscriptionKind));
    }
    switch (e?.extraInfo?.subscriptionKind) {
      case SUBSCRIPTIONKIND.HARDWARE_INCLUSIVE:
        redirectPage = `${WebHardwareInclusiveRoutePath.SELECT_PRINTER}`;
        break;
      case SUBSCRIPTIONKIND.BROTHER_PLUS:
        redirectPage = `${WebHardwareInclusiveRoutePath.SELECT_PRINTER}?src=${QUERY_PARAMS.BROTHER_PLUS_SRC}&plan=${QUERY_PARAMS.BROTHER_PLUS_FREE_PLAN}`;
        break;
      default:
        redirectPage = WebCustomerRoutePaths.SELECT_PRINTER;
        break;
    }
    yield put({
      type: actionTypes.FETCH_USER_ACCOUNT_ERROR,
      message: msg,
      redirectToLandingPage: true,
      redirectPage: redirectPage
    });
  }
}

function* UserAccount() {
  yield takeEvery(actionTypes.FETCH_USER_ACCOUNT, fetchUserAccount);
}

export default UserAccount;
export { fetchUserAccount };
